import type { ActionCreator, AnyAction } from 'redux'

import { actionTypes } from 'actions/actionTypes'
import { clickPayWithGooglePay } from 'actions/trackingKeys'

export const trackClickWithGooglePay: ActionCreator<AnyAction> = () => ({
  type: actionTypes.TRACKING,
  trackingData: { actionType: clickPayWithGooglePay },
})
